module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-BlackOblique.97bb2e0a.ttf";